import { render, staticRenderFns } from "./PatientChooseTime.vue?vue&type=template&id=2f4135b6&scoped=true&"
import script from "./PatientChooseTime.vue?vue&type=script&lang=js&"
export * from "./PatientChooseTime.vue?vue&type=script&lang=js&"
import style0 from "./PatientChooseTime.vue?vue&type=style&index=0&id=2f4135b6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4135b6",
  null
  
)

export default component.exports